import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import styled from "styled-components";

const StyledTable = styled(Table)`
  &.MuiTable-root {
    width: 100%;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-spacing: 0 0;
    border-collapse: separate;
    border: 1px solid rgba(224, 224, 224, 1);
    border-radius: 4px;
  }
`;
const StyledTableHead = styled(TableHead)`
  &.MuiTableHead-root {
    height: 45px !important;
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }
`;
const StyledTableRow = styled(TableRow)`
  &.MuiTableRow-root {
    background-color: white;
  }
  &.MuiTableRow-root .MuiTableRow-hover:hover,
  &.MuiTableRow-root .Mui-selected {
    background-color: rgb(237 244 255);
  }
`;

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px;
    line-height: 18px;
    color: #16191f;
    font-weight: 800;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    line-height: 24px;
    padding: 0.4rem 0 0.4rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }
`;

const StyledTableBoreredCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px;
    line-height: 18px;
    color: #16191f;
    font-weight: 800;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    line-height: 24px;
    padding: 0.4rem 0 0.4rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
    &:not(:last-child) {
      border-right: 1px solid rgba(224, 224, 224, 1);
    }
  }
`;

const StyledRosterCell = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px;
    line-height: 18px;
    color: grey;
    font-weight: 800;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    line-height: 24px;
    padding: 0.4rem 0 0.4rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }
`;

const CleanCell = styled(TableCell)`
  &.MuiTableCell-root {
    border: none;
    padding: 0;
  }
`;

const StyledCellSm = styled(TableCell)`
  &.MuiTableCell-head {
    font-size: 12px !important;
    line-height: 12px;
    color: #16191f;
    font-weight: 700;
    text-transform: capitalize;
  }
  &.MuiTableCell-root {
    font-size: 12px !important;
    line-height: 12px;
    padding: 0.4rem 0 0.4rem 16px;

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      padding-right: 1.5rem;
    }
  }
`;

export {
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledTableCell,
  CleanCell,
  StyledCellSm,
  StyledRosterCell,
  StyledTableBoreredCell,
};
